<template>
  <div class="invoice-picker-link text-end mb-1">
    <div @click="fillInvoice('sender')">
      {{ $t("Fill with sender data") }}
      <v-icon
        end
        class="icon-flipped"
        color="primary"
        size="22"
      >
        mdi-keyboard-backspace
      </v-icon>
    </div>
    <div @click="fillInvoice('patient')">
      {{ $t("Fill with patient data") }}
      <v-icon
        end
        class="icon-flipped"
        color="primary"
        size="22"
      >
        mdi-keyboard-backspace
      </v-icon>
    </div>
    <div
      class="sender-picker-link text-end mb-1"
      @click="fillInvoice('profile')"
    >
      <div>
        {{ $t("Fill with profile data") }}
        <v-icon
          end
          class="icon-flipped"
          color="primary"
          size="22"
        >
          mdi-keyboard-backspace
        </v-icon>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { FORM_CONTROLS } from "@/utils/constants";
import { Order } from "@/entities/order";
import { Patient } from "@/entities/patient";
import { User } from "@/entities/user";
import { useOrdersStore } from "@/stores/orders";
import { usePatientsStore } from "@/stores/patients";

const ordersStore = useOrdersStore();
const patientsStore = usePatientsStore();

const emit = defineEmits<{
  (e: 'fillInvoice', data: any): void;
}>();

const props = defineProps<{
  senderData: User | null
}>()

const getPatient = computed<Patient>(() => patientsStore.getPatient);
const getOrder = computed<Order>(() => ordersStore.getOrder);

const getOrderFormControlByName = ordersStore.getOrderFormControlByName;

const patient = computed(() => getPatient.value);
const order = computed(() => getOrder.value);

function fillInvoice(value: string) {
  let invoiceData: any;

  if (value === "sender") {
    invoiceData = {
      firstName: getOrderFormControlByName(FORM_CONTROLS.sender_firstName)?.value,
      lastName: getOrderFormControlByName(FORM_CONTROLS.sender_lastName)?.value,
      street: getOrderFormControlByName(FORM_CONTROLS.sender_street)?.value,
      postalCode: getOrderFormControlByName(FORM_CONTROLS.sender_postalCode)?.value,
      city: getOrderFormControlByName(FORM_CONTROLS.sender_city)?.value,
      country: getOrderFormControlByName(FORM_CONTROLS.sender_country)?.value,
      email: getOrderFormControlByName(FORM_CONTROLS.sender_email)?.value,
    };
  } else if (value === "patient") {
    if (order.value.patientId) {
      invoiceData = patient.value;
    } else {
      invoiceData = {
        firstName: getOrderFormControlByName(FORM_CONTROLS.patient_firstName)?.value,
        lastName: getOrderFormControlByName(FORM_CONTROLS.patient_lastName)?.value,
      };
    }
  } else if (value === "profile") {
    invoiceData = props.senderData;
  } else {
    invoiceData = {};
  }

  emit('fillInvoice', invoiceData);
}
</script>

<style lang="scss">
.invoice-picker-link {
  color: rgb(var(--v-theme-primary));

  :hover {
    cursor: pointer;
  }
}
</style>
